import { Swiper, Autoplay, FreeMode, Navigation, Scrollbar } from '../vendor/swiper.js';

/**
 * Catalog subsection chips slider (.section_block / front_sections_only).
 * @param {ParentNode} [root=document]
 * @returns {import('swiper').default[]}
 */
export function initSectionsChips(root = document) {
  const instances = [];
  const elements = root.querySelectorAll('.sections-chips.swiper');

  elements.forEach((el) => {
    if (!(el instanceof HTMLElement) || el.dataset.swiperInited === '1') {
      return;
    }

    const prevEl = el.querySelector('.swiper-button-prev');
    const nextEl = el.querySelector('.swiper-button-next');
    const scrollbarEl = el.querySelector('.swiper-scrollbar');

    /** @type {import('swiper').SwiperOptions} */
    const options = {
      modules: [Navigation, FreeMode, Scrollbar, Autoplay],
      slidesPerView: 'auto',
      // spaceBetween instead of CSS gap — Swiper ignores wrapper gap in max translate
      freeMode: {
        enabled: true,
        momentum: true,
      },
      watchOverflow: true,
      observer: true,
      observeParents: true,
      navigation: false,
    };

    if (prevEl || nextEl) {
      options.navigation = {
        prevEl: prevEl || undefined,
        nextEl: nextEl || undefined,
      };
    }

    if (scrollbarEl) {
      options.scrollbar = {
        el: scrollbarEl,
        draggable: true,
      };
    }

    const instance = new Swiper(el, options);
    el.dataset.swiperInited = '1';
    instances.push(instance);
  });

  return instances;
}
